export default __webpack_public_path__ + "c0572da2a1c885fd6307f52cb0e7d7e0.png";